export default (params) => ({
  trigger: {
    name: 'content_blocks.detailed_visual_entrances.select_arrow',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      visible_indices: {
        type: 'integer',
      },
      visible_items: {
        type: 'string',
      },
      direction: {
        enum: [
          'next',
          'previous',
        ],
      },
      correlation_id: {
        type: 'string',
      },
    },
    event: {
      name: 'select_direction',
      params: {
        sub_feature: null,
      },
    },
    nonInt: false,
  },
});
